import React from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import { formOptions } from "./constants";

const BuildingStructure2 = ({ formData, handleChange, errors }) => {
  return (
    <>
<FormGroup>
        <Label for="sloof">31. Sloof</Label>
        <Input 
          type="select" 
          name="sloof" 
          id="sloof" 
          value={formData.sloof} 
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.sloof ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.sloof && <div className="invalid-feedback">{errors.sloof}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="pintuJendelaKonsen">32. Pintu, Jendela, Konsen</Label>
        <Input 
          type="select" 
          name="pintuJendelaKonsen" 
          id="pintuJendelaKonsen" 
          value={formData.pintuJendelaKonsen}
          onChange={handleChange}  
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.pintuJendelaKonsen ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.pintuJendelaKonsen && <div className="invalid-feedback">{errors.pintuJendelaKonsen}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="ventilasi">33. Ventilasi</Label>
        <Input 
          type="select" 
          name="ventilasi" 
          id="ventilasi" 
          value={formData.ventilasi} 
          onChange={handleChange} 
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.ventilasi ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.ventilasi && <div className="invalid-feedback">{errors.ventilasi}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="materialLantaiTerluas">34. Material Lantai Terluas</Label>
        {!formData.isManualLantai ? (
          <Input 
            type="select" 
            name="materialLantaiTerluas" 
            id="materialLantaiTerluas" 
            value={formData.materialLantaiTerluas} 
            onChange={handleChange}
            disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
            className={errors.materialLantaiTerluas ? "is-invalid" : ""}  
          >
            <option value="">Pilih</option>
            {formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung" && <option value="Tidak Layak">Tidak Layak</option>}
            {formOptions.materialLantaiTerluas.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        ) : (
          <div>
            <Input
              type="text"
              name="materialLantaiTerluasManual"
              id="materialLantaiTerluasManual"
              value={formData.materialLantaiTerluas || ''}
              onChange={handleChange}
              placeholder="Masukkan material lantai lainnya"
            />
            <Button 
              color="link" 
              size="sm" 
              onClick={() => {
                // This should be handled by parent component
                console.log("Switch back to select");
              }}
            >
              Kembali ke pilihan
            </Button>
          </div>
        )}
        {errors.materialLantaiTerluas && <div className="invalid-feedback">{errors.materialLantaiTerluas}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="kondisiLantai">35. Kondisi Lantai</Label>
        <Input 
          type="select" 
          name="kondisiLantai" 
          id="kondisiLantai" 
          value={formData.kondisiLantai}
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.kondisiLantai ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.kondisiLantai && <div className="invalid-feedback">{errors.kondisiLantai}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="materialDindingTerluas">36. Material Dinding Terluas</Label>
        {!formData.isManualDinding ? (
          <Input 
            type="select" 
            name="materialDindingTerluas" 
            id="materialDindingTerluas" 
            value={formData.materialDindingTerluas} 
            onChange={handleChange} 
            disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
            className={errors.materialDindingTerluas ? "is-invalid" : ""}  
          >
            <option value="">Pilih</option>
            {formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung" && <option value="Tidak Layak">Tidak Layak</option>}
            {formOptions.materialDindingTerluas.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        ) : (
          <div>
            <Input
              type="text"
              name="materialDindingTerluasManual"
              id="materialDindingTerluasManual"
              value={formData.materialDindingTerluasManual || ''}
              onChange={handleChange}
              placeholder="Masukkan material Dinding lainnya"
            />
            <Button 
              color="link" 
              size="sm" 
              onClick={() => {
                // This should be handled by parent component
                console.log("Switch back to select");
              }}
            >
              Kembali ke pilihan
            </Button>
          </div>
        )}
        {errors.materialDindingTerluas && <div className="invalid-feedback">{errors.materialDindingTerluas}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="kondisiDinding">37. Kondisi Dinding</Label>
        <Input 
          type="select" 
          name="kondisiDinding" 
          id="kondisiDinding" 
          value={formData.kondisiDinding} 
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.kondisiDinding ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.kondisiDinding && <div className="invalid-feedback">{errors.kondisiDinding}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="materialPenutupAtapTerluas">38. Material Penutup Atap Terluas</Label>
        {!formData.isManualPenutupAtap ? (
          <Input 
            type="select" 
            name="materialPenutupAtapTerluas" 
            id="materialPenutupAtapTerluas" 
            value={formData.materialPenutupAtapTerluas} 
            onChange={handleChange}
            disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
            className={errors.materialPenutupAtapTerluas ? "is-invalid" : ""}  
          >
            <option value="">Pilih</option>
            {formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung" && <option value="Tidak Layak">Tidak Layak</option>}
            {formOptions.materialPenutupAtapTerluas.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input> 
        ) : (
          <div>
            <Input
              type="text"
              name="materialPenutupAtapTerluasManual"
              id="materialPenutupAtapTerluasManual"
              value={formData.materialPenutupAtapTerluas || ''}
              onChange={handleChange}
              placeholder="Masukkan material Penutup atap lainnya"
            />
            <Button 
              color="link" 
              size="sm" 
              onClick={() => {
                // This should be handled by parent component
                console.log("Switch back to select");
              }}
            >
              Kembali ke pilihan
            </Button>
          </div>
        )}
        {errors.materialPenutupAtapTerluas && <div className="invalid-feedback">{errors.materialPenutupAtapTerluas}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="kondisiPenutupAtap">39. Kondisi Penutup Atap</Label>
        <Input 
          type="select" 
          name="kondisiPenutupAtap" 
          id="kondisiPenutupAtap" 
          value={formData.kondisiPenutupAtap} 
          onChange={handleChange}
          disabled={formData.pondasi === "Tidak Layak" && formData.modelRumah !== "Panggung"}
          className={errors.kondisiPenutupAtap ? "is-invalid" : ""}  
        >
          <option value="">Pilih</option>
          {formOptions.kondisiOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.kondisiPenutupAtap && <div className="invalid-feedback">{errors.kondisiPenutupAtap}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="luasRumah">40. Luas Rumah (m²)</Label>
        <Input 
          type="number" 
          name="luasRumah" 
          id="luasRumah" 
          value={formData.luasRumah} 
          onChange={handleChange}
          className={errors.luasRumah ? "is-invalid" : ""}  
        />
        {errors.luasRumah && <div className="invalid-feedback">{errors.luasRumah}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="luasTanah">41. Luas Tanah (m²)</Label>
        <Input 
          type="number" 
          name="luasTanah" 
          id="luasTanah" 
          value={formData.luasTanah} 
          onChange={handleChange} 
          className={errors.luasTanah ? "is-invalid" : ""}  
        />
        {errors.luasTanah && <div className="invalid-feedback">{errors.luasTanah}</div>}
      </FormGroup>

      </>
  );
};

export default BuildingStructure2;
